import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { transparent, light, info, secondary } = colors;
const { size } = typography;

const outlined = {
  base: {
    minHeight: pxToRem(40),
    color: light.main,
    borderColor: light.main,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      opacity: 0.75,
      backgroundColor: transparent.main,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: colors.primary.main,
    color: colors.primary.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: colors.primary.focus,
      color: colors.primary.focus,
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,
    color: secondary.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: secondary.focus,
      color: secondary.focus,
    },
  },

  success: {
    backgroundColor: transparent.main,
    borderColor: colors.success.main,
    color: colors.success.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: colors.success.focus,
      color: colors.success.focus,
    },
  },

  warning: {
    backgroundColor: transparent.main,
    borderColor: colors.warning.main,
    color: colors.warning.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: colors.warning.focus,
      color: colors.warning.focus,
    },
  },

  error: {
    backgroundColor: transparent.main,
    borderColor: colors.error.main,
    color: colors.error.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: colors.error.focus,
      color: colors.error.focus,
    },
  },

  info: {
    backgroundColor: transparent.main,
    borderColor: info.main,
    color: info.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: info.focus,
      color: info.focus,
    },
  },
};

export default outlined;
